import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Check, ChevronsUpDown, X } from "lucide-react";

// options: [{ value, label, sub }]
export default function MultiSelect({ options = [], value = [], onChange, placeholder = "Select…", testid = "multi-select" }) {
  const selected = options.filter((o) => value.includes(o.value));
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`${testid}-trigger`}
          className="mt-1.5 w-full flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-left text-sm hover:border-slate-300 transition-colors min-h-[40px]">
          <div className="flex-1 flex flex-wrap gap-1">
            {selected.length === 0 ? (
              <span className="text-slate-400">{placeholder}</span>
            ) : selected.map((o) => (
              <span key={o.value} className="inline-flex items-center gap-1 rounded-md bg-lime-100 text-lime-800 text-xs px-1.5 py-0.5">
                {o.label}
                <X className="h-3 w-3 cursor-pointer hover:text-lime-950" onClick={(e) => { e.stopPropagation(); toggle(o.value); }} />
              </span>
            ))}
          </div>
          <ChevronsUpDown className="h-4 w-4 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-1 max-h-64 overflow-y-auto" align="start" data-testid={`${testid}-content`}>
        {options.length === 0 ? (
          <p className="text-sm text-slate-400 px-2 py-3 text-center">No options</p>
        ) : options.map((o) => {
          const on = value.includes(o.value);
          return (
            <div key={o.value} role="button" tabIndex={0} onClick={() => toggle(o.value)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(o.value); } }} data-testid={`${testid}-opt-${o.value}`}
              className="w-full flex items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-slate-50 cursor-pointer">
              <Checkbox checked={on} className="data-[state=checked]:bg-lime-500 data-[state=checked]:border-lime-500 pointer-events-none" />
              <span className="flex-1 min-w-0">
                <span className="text-slate-800 truncate block">{o.label}</span>
                {o.sub && <span className="text-xs text-slate-400 truncate block">{o.sub}</span>}
              </span>
              {on && <Check className="h-4 w-4 text-lime-500" />}
            </div>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
